import React from "react";
import { linkifyChatMessage } from "../../utils/chatMessageLinks";
import "./ChatMessageText.css";

const ChatMessageText = ({ text }) => (
  <p>
    {linkifyChatMessage(text).map((part, index) => (
      part.type === "link" ? (
        <a
          className="chat-message-link"
          href={part.href}
          key={`${part.href}-${index}`}
          target="_blank"
          rel="noopener noreferrer"
        >
          {part.text}
        </a>
      ) : (
        <React.Fragment key={`text-${index}`}>{part.text}</React.Fragment>
      )
    ))}
  </p>
);

export default ChatMessageText;
